import { useCallback, useContext } from 'react';
import ForwardRefContext from 'src/contexts/ForwardRefContext';

export const useInsertCodeToEditor = () => {
  const { codeEditorRef } = useContext(ForwardRefContext);

  const insertCodeToEditor = useCallback(
    ({ codeContent }: { codeContent: string }) => {
      const view = codeEditorRef.current;

      view?.dispatch({
        changes: {
          from: view.state.selection.main.head,
          insert: codeContent,
        },
      });
    },
    [codeEditorRef],
  );

  return { insertCodeToEditor };
};
